import React from 'react';

//forms
import FormHeader from "../../../form/ModamilyAppFormHeader";
import ButtonGroup from "../../../form/ModamilyAppButtonGroup";

// cosntants
import Options from "../../../../constants/formOptions";

const EyeColor = ({ searchPreferences,handleUpdate,selectedEyeColorIndexes }) => (
  <div className="searchPrefForm">
		<div className="searchPrefIncomeRangeFormContainer">
			<FormHeader text="Eye Color" />
			<ButtonGroup
				manualSelection={true}
				customSelected={selectedEyeColorIndexes}
				data={Options.eyeColor}
				onButtonClick={(value, index) => {
					if (index > -1) {
						if(value.toLowerCase() === 'no preference') {
							searchPreferences.eyeColor = [value.toLowerCase()]
						} else {
							const indexOfPNTS = searchPreferences.eyeColor.indexOf('no preference');
							if ( indexOfPNTS > -1) { 
								searchPreferences.eyeColor.splice(
									indexOfPNTS,
									1
								);
							}
							searchPreferences.eyeColor.push(
								value.toLowerCase()
							);
						}
					} else {
						searchPreferences.eyeColor.splice(
							searchPreferences.eyeColor.indexOf(
								value.toLowerCase()
							),
							1
						);
					}
					handleUpdate(searchPreferences);
				}}
			/>
		</div>
	</div>
);

export default EyeColor;